const BASE = (window.site && window.site.screeningApiBaseUrl) || "";
const appname = window.app && window.app.appName;

async function api(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...opts.headers },
    ...opts,
  });
  const data = await res.json();
  if (!res.ok || (data.statusCode && data.statusCode !== 200)) {
    throw new Error(data.error || data.message || `HTTP ${res.status}`);
  }
  return data;
}

export const checkUser = (email) =>
  api("/auth/check-user?appname=" + appname, { method: "POST", body: JSON.stringify({ email }) });

export const signIn = (email, password) =>
  api("/auth/face-sign-in?appname=" + appname, { method: "POST", body: JSON.stringify({ email, password, type: "signIn" }) });

export const initiateSignUp = (email, password) =>
  api("/auth/initiate-sign-up?appname=" + appname, { method: "POST", body: JSON.stringify({ email, password }) });

export const confirmSignUp = (email, code) =>
  api("/auth/confirm-sign-up?appname=" + appname, { method: "POST", body: JSON.stringify({ email, code }) });

export const completeRegistration = (payload) =>
  api("/auth/complete-registration?appname=" + appname, { method: "POST", body: JSON.stringify(payload) });

export const faceSignIn = (email, selfieS3Key) =>
  api("/auth/face-sign-in?appname=" + appname, {
    method: "POST",
    body: JSON.stringify({ email, selfieS3Key, type: "faceSignIn" }),
  });

export const analyzeDocument = (s3Key, docType) =>
  api(`/id/analyze?appname=${appname}`, {
    method: "POST",
    body: JSON.stringify({ s3Key, docType }),
  });

export const createLivenessSession = () =>
  api("/face/liveness-session", { method: "POST" });

export const verifyFace = (sessionId, idImageS3Key) =>
  api("/face/verify", { method: "POST", body: JSON.stringify({ sessionId, idImageS3Key }) });

export const compareFace = (selfieS3Key, idImageS3Key, userId) =>
  api(`/face/compare?appname=${appname}`, {
    method: "POST",
    body: JSON.stringify({ selfieS3Key, idImageS3Key, userId }),
  });

export const createUserProfile = (profileData) =>
  api("/user/create-profile", { method: "POST", body: JSON.stringify(profileData) });
